<template>
  <div class="common-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>展会设置</BreadcrumbItem>
          <BreadcrumbItem>需求表设置</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">需求表设置</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="show=true;">
          <span>新增</span>
        </div>
      </div>
    </div>
    <div class="common-down">
      <Table :border="false" row-key="id" :columns="columns" :data="downList" v-if="downList.length" height="1000">
        <template slot-scope="{ row }" slot="name">{{row.name}}</template>
        <template slot-scope="{ row }" slot="type">
          <span v-if="row.type === 0">下载需求表</span>
          <span v-if="row.type === 1">承诺书</span>
          <span v-if="row.type === 2">展位装修</span>
          <span v-if="row.type === 3">运输服务</span>
          <span v-if="row.type === 4">会展会务服务</span>
        </template>
        <template slot-scope="{ row }" slot="upFileUrl">
          <a :href="row.upFileUrl" target="blank">点击查看</a>
        </template>
        <template slot-scope="{ row }" slot="isNeedReceipt">{{row.isNeedReceipt ? '是': '否'}}</template>
        <template slot-scope="{ row }" slot="showIndex">{{row.showIndex}}</template>
        <template slot-scope="{ row }" slot="action">
          <a href="javascript:;" @click="showEdit(row)">编辑</a> |
          <Poptip confirm title="确认删除吗?" @on-ok="delItem(row.id)" placement="left">
            <span style="color:red;cursor: pointer;">删除</span>
          </Poptip>
        </template>
      </Table>
      <div v-else style="line-height:500px;text-align:center;">暂无数据</div>
    </div>

    <commonAdDown :show="show" @finish="init()" @close="show=false;" />
    <commonAdDownEdit :show="show2" :editInfo="editInfo" @finish="init()" @close="show2=false;editInfo=null;" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import commonAdDown from "./components/common-ad-down.vue";
import commonAdDownEdit from "./components/common-ad-down-edit.vue";
import Docx from "@assets/img/type/docx.png";
import Png from "@assets/img/type/png.png";
import Jpg from "@assets/img/type/jpg.png";
import Pdf from "@assets/img/type/pdf.png";
import Ppt from "@assets/img/type/ppt.png";
import Txt from "@assets/img/type/txt.png";
import Unkown from "@assets/img/type/unknow.png";
import Xls from "@assets/img/type/xls.png";
import Zip from "@assets/img/type/zip.png";

export default {
  name: "host-common-down",
  data () {
    return {
      editInfo: null,
      show2: false,
      imgSrc: Png,
      pageIndex: 1,
      pageSize: 99,
      totalCount: 0,
      showTabs: "1",
      show: false,
      downList: [],
      downType: "中文文件",
      columns: [
        {
          title: "名称",
          key: "name",
          slot: "name",
          align: "center"
        },
        {
          title: "类型",
          key: "type",
          slot: "type",
          align: "center"
        },
        {
          title: "模板文件",
          key: "upFileUrl",
          slot: "upFileUrl",
          align: "center"
        },
        {
          title: "需要上传回执",
          key: "isNeedReceipt",
          slot: "isNeedReceipt",
          align: "center"
        },
        {
          title: "显示顺序",
          key: "showIndex",
          slot: "showIndex",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
    };
  },
  created () {
    this.init();
  },
  computed: {
    ...mapGetters({
      exhibition: "hostSetModule/getHostExhibition"
    }),
    imgArr () {
      return {
        doc: Docx,
        docx: Docx,
        png: Png,
        jpg: Jpg,
        jpeg: Jpg,
        pdf: Pdf,
        ppt: Ppt,
        pptx: Ppt,
        txt: Txt,
        unkown: Unkown,
        xls: Xls,
        xlsx: Xls,
        zip: Zip
      };
    }
  },
  methods: {
    ...mapActions({
      getExhibitionBaseNeedSettleById: "hostNeed/getExhibitionBaseNeedSettleById",
      delExhibitionBaseNeedSettle: "hostNeed/delExhibitionBaseNeedSettle",
    }),
    async init () {
      let result = await this.getExhibitionBaseNeedSettleById(this.exhibition.id);
      console.log('getExhibitionBaseNeedSettleById', result);
      if (result.length) {
        this.downList = result;
      }
    },
    typeChange (e) {
      this.init();
    },
    fileName (file) {
      if (!file) return;
      //截取文件后缀
      let file_name = file.substring(file.lastIndexOf(".") + 1);
      let name = this.imgArr[file_name];
      return name ? name : this.imgArr["unkown"];
    },
    async delItem (item) {
      let result = await this.delExhibitionBaseNeedSettle(item);
      if (result.successed) {
        this.$Message.success("删除成功");
        setTimeout(() => {
          this.init();
        }, 500);
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    showEdit (item) {
      this.show2 = true;
      this.editInfo = item;
    },
  },
  components: {
    commonAdDown,
    commonAdDownEdit,
  }
};
</script>

<style lang="scss" scoped>
.common-down {
  margin: 24px;
  background: #fff;
  min-height: 500px;
  min-width: 600px;
  .cd {
    &-box {
      padding: 0 30px;
    }
    &-item {
      height: 90px;
      border-bottom: 1px solid #e9e9e9;
      &-l {
        display: flex;
        height: 90px;
        align-items: center;
        img {
          width: 55px;
          height: 55px;
          margin-right: 20px;
        }
        span {
          font-size: 16px;
          color: #333;
        }
      }
      &-r {
        display: flex;
        height: 90px;
        align-items: center;
      }
    }
  }
}
</style>